import { createSlice } from '@reduxjs/toolkit';

// Load auth data from localStorage
const loadAuthData = () => {
  try {
    const authData = localStorage.getItem('authData');
    if (authData) {
      const { user, token, refreshToken } = JSON.parse(authData);
      console.log('🔍 Loading auth data from localStorage:', { user, token: token ? 'exists' : 'missing' });
      // Map userType to role for menu filtering (same as setCurrentUser)
      const userWithRole = {
        ...user,
        role: user.userType || user.role,
      };
      console.log('✅ User with role mapping:', { 
        userType: user.userType, 
        role: userWithRole.role,
        fullUser: userWithRole 
      });
      return { isLogin: true, currentUser: userWithRole, token, refreshToken };
    }
  } catch (error) {
    console.error('❌ Failed to load auth data:', error);
  }
  console.log('⚠️ No auth data found in localStorage');
  return { isLogin: false, currentUser: {}, token: null, refreshToken: null };
};

const initialState = loadAuthData();

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser(state, action) {
      const { user, token, refreshToken } = action.payload;
      // Map userType to role for menu filtering
      const userWithRole = {
        ...user,
        role: user.userType || user.role,
      };
      state.currentUser = userWithRole;
      state.token = token;
      state.refreshToken = refreshToken || null;
      state.isLogin = true;

      // Persist to localStorage
      localStorage.setItem('authData', JSON.stringify({ user: userWithRole, token, refreshToken: refreshToken || null }));
    },
    logout(state) {
      state.currentUser = {};
      state.token = null;
      state.refreshToken = null;
      state.isLogin = false;

      // Clear localStorage
      localStorage.removeItem('authData');
    },
  },
});

export const { setCurrentUser, logout } = authSlice.actions;
const authReducer = authSlice.reducer;

export default authReducer;
